import { Presentation } from "../models/presentation.models";
import { UiActionStore } from "../models/ui-action.models";
import { UiDefinition } from "../models/ui-definition.models";

export const DYNAMIC_FEATURE_KEY = 'dynamic';

export interface LocalStoreEntry {
    UiDefValues: Record<string, any>;
    UiDefChilds: Record<string, LocalStoreEntry>;
}

export interface DynamicState {
    uiDefinition?: UiDefinition;
    local: LocalStoreEntry;
    session: Record<string, any>;
    presentation?: Presentation;
    actions: UiActionStore[];
}

export const initialDynamicState: DynamicState = {
    uiDefinition: null,
    local: {
        UiDefValues: {},
        UiDefChilds: {},
    },
    session: {},
    presentation: null,
    actions: [],
};